import {MutationTree} from "vuex";
import Download from '../ts/DownloadItemInterface';

export const mutations: MutationTree<any> = {

    setDownloadsLoading(state: any, payload: boolean) {
        state.loading = payload;
    },

    setDownloads(state:any, payload: any) {
        state.items = payload;
    },

    resetDownloadsCache(state:any) {
        state.expire = null;
    },

    updateDefaultSortBy(state:any, defaultSort: string) {
        state.defaultSortBy = defaultSort;
    },

    updateDefaultSortDesc(state:any, defaultSort: boolean) {
        state.defaultSortDesc = defaultSort;
    },

    deleteItem(state:any, id: number) {
        const index = state.items.findIndex( (item: Download) => item.id === id);

        if (index!==null) {
            state.items.splice(index,1);
        }
    }
};
